module.exports = __webpack_public_path__ + "img/icon-document-grey.88b2e278.svg";